import { Link } from "react-router-dom";
import { Award, Gift, Users } from "lucide-react";
import { SimplePage } from "@/components/SimplePage";
import { AWARD_REASONS } from "@/lib/rewards";

const EARN = [
  ["In the app", "Every polite request earns an acorn. Gratitude words like “I would be so grateful…” or a heartfelt thank-you earn golden acorns. Practice scenes and apologies earn acorns, too."],
  ["In real life, from you", "When you notice great manners away from the screen, give a golden acorn in the Family area. Pick a reason and add a proud note your child can read."],
  ["Saving up", "Acorns and golden acorns add up toward rewards you choose. When a reward is given, its cost is spent from their savings. Their lifetime jar keeps growing."],
];

const IDEAS = {
  "Kids 4–12": ["Pick the family movie", "Extra story time", "Choose what's for dinner", "A trip to the park", "One-on-one date with a parent", "Ice cream outing", "A new book or small toy", "Stay up 20 minutes later"],
};

export default function GoldenGuide() {
  return (
    <SimplePage testId="golden-guide-page" back="/family" backLabel="Family area">
      <p className="pp-label">For parents</p>
      <h1 className="pp-h1">How golden acorns work</h1>
      <p className="pp-sub max-w-2xl">Rewards work best when they celebrate effort and character, not perfection. You know your child better than anyone, so you're always in charge of what earns a golden acorn and what rewards cost.</p>
      <section className="pp-card mt-8" data-testid="guide-earn">
        <h2 className="pp-h2">Three ways acorns grow</h2>
        <ol className="pp-steps">{EARN.map(([t, d], i) => <li key={t}><span>{i + 1}</span><p><strong className="pp-step-title">{t}.</strong> {d}</p></li>)}</ol>
      </section>
      <section className="pp-card mt-6" data-testid="guide-reasons">
        <h2 className="pp-h2 flex items-center gap-2"><Award className="h-5 w-5 text-amber-500" /> Golden acorn moments to look for</h2>
        <ul className="pp-legal-list mt-3">{AWARD_REASONS.map((r) => <li key={r}>{r}</li>)}</ul>
        <p className="text-sm opacity-75 mt-3" data-testid="guide-apology-tip">Heard all 3 steps of an apology (name the problem, say sorry, do the repair work) without being asked? That deserves a golden acorn.</p>
        <p className="text-sm opacity-75 mt-2">Bonus tip: ask your child's teacher for a quick note about respect in class and with peers, and celebrate it together.</p>
      </section>
      <section className="pp-card mt-6" data-testid="guide-ideas">
        <h2 className="pp-h2 flex items-center gap-2"><Gift className="h-5 w-5" /> Reward ideas to work toward</h2>
        <div className="grid gap-6 mt-3">
          {Object.entries(IDEAS).map(([k, v]) => <div key={k}><p className="pp-label">{k}</p><ul className="pp-legal-list">{v.map((x) => <li key={x}>{x}</li>)}</ul></div>)}
        </div>
        <p className="text-sm opacity-75 mt-3">Experiences and time together often mean more than things. Keep early rewards small and quick so kids feel success.</p>
      </section>
      <div className="pp-actions">
        <Link to="/family#rewards" className="pp-primary" data-testid="guide-family-link"><Users className="h-5 w-5" /> Create your own rewards</Link>
        <Link to="/rewards" className="pp-ghost" data-testid="guide-rewards-link"><Gift className="h-4 w-4" /> See the rewards list</Link>
      </div>
    </SimplePage>
  );
}
